<template>
	<page enable-flex :create-button="auth('b_app_purchase_offline_create')" @create="mp.navigateWeb('/purchase/offline/create')">
		<view-list ref="view" work-type="2">
			<template #filter>
				<m-search>
					<m-search-item label="采购单号">
						<c-input name="purchase_code"></c-input>
					</m-search-item>
					<m-search-item label="供应商">
						<c-select name="supplier_id" async @search="searchSupplier"></c-select>
					</m-search-item>
					<m-search-item label="供应商联系人">
						<c-select name="supplier_contact_id" async @search="searchUser('2', arguments[0], arguments[1])"></c-select>
					</m-search-item>
					<m-search-item label="采购部门">
						<c-select name="purchase_dept_id" async @search="searchDepartment"></c-select>
					</m-search-item>
					<m-search-item label="采购人">
						<c-select name="purchase_user_id" async @search="searchUser('1', arguments[0], arguments[1])"></c-select>
					</m-search-item>
					<m-search-item label="创建人">
						<c-select name="create_user_id" async @search="searchUser('1', arguments[0], arguments[1])"></c-select>
					</m-search-item>
					<m-search-item label="创建时间">
						<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
					</m-search-item>
				</m-search>
			</template>

			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #number>
						{{data.purchase_code}}
					</template>

					<template #state>
						<c-state dict="PURCHASE_ORDER_STATE" :value="data.purchase_state" type="state"></c-state>
					</template>

					<template #default>
						<c-field>
							<div class="flex" style="gap: .14rem;">
								<div class="flex" style="gap: .08rem;">
									<c-state color="#AD78CE" type="tag">收</c-state>
									<span style="color: #000;">{{data.purchase_product_count}}台</span>
								</div>
								<div class="flex" style="gap: .08rem;">
									<c-state color="#0078FF" type="tag">验</c-state>
									<span style="color: #000;">{{data.checked_count}}台</span>
								</div>
								<div class="flex" style="gap: .08rem;">
									<c-state color="#FF0000" type="tag">退</c-state>
									<span style="color: #000;">{{data.return_count}}台</span>
								</div>
							</div>
						</c-field>
						<c-field label="采购供应商">{{data.supplier_name}}</c-field>
						<c-field label="采购人">{{data.purchase_user_realname}}</c-field>
						<c-field label="创建部门">{{data.create_dept_name||'-'}}</c-field>
						<c-field label="采购总价"><span style="color: #FF6900;">￥{{data.purchase_money}}</span></c-field>
					</template>

					<template #operate>
						<c-button v-if="auth('b_app_purchase_offline_view')" hollow @click="globalDialog('purchaseOrderDetail', {props: {orderId: data.id}})">详情</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		
		methods: {
			searchSupplier(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'SUPPLIER',
						keyword: keyword
					},
					success: data => {
						resolve(data);
					}
				})
			},

			searchDepartment(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'DEPARTMENT',
						keyword: keyword
					},
					success: data => {
						resolve(data);
					}
				});
			},

			searchUser(type, keyword, resolve) {
				let paramData = {
					user_type: type,
					options_code: 'SYSUSER',
					keyword: keyword
				};
				this.request({
					url: '/system/options',
					data: paramData,
					success: data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>